import React, { useState, useEffect, useRef } from 'react';
import { useDropzone } from 'react-dropzone';

import { Upload } from 'app/components/Icons';

import {
	Container,
	Thumbs,
	ThumbsContainer,
	Title,
	DropZoneContainer,
	UploadIconContainer,
} from './UploaderComponents';

export interface FileWithPreview extends File {
	preview: string;
}

export function Uploader({
	title,
	accept = 'image/*',
	onUpload,
	uploaded = [],
	onDelete,
	disabled,
	className,
	dropZoneClassName,
	thumbsClassName,
	thumbClassName,
	titleClassName,
	allowTitleClick,
}: any) {
	const [files, setFiles] = useState<FileWithPreview[]>([]);
	const [loading] = useState<boolean>(false);

	const handleUpload = async (uploadingFile: FileWithPreview) => {
		if (onUpload) {
			await onUpload(uploadingFile);

			setFiles(files.filter((file) => file.preview !== uploadingFile.preview));
		}
	};

	const dropZoneRef = useRef(null);

	const { getRootProps, getInputProps } = useDropzone({
		accept,
		disabled,
		onDrop: (acceptedFiles) => {
			const filesWithPreview: FileWithPreview[] = acceptedFiles.map((file) =>
				Object.assign(file, {
					preview: URL.createObjectURL(file),
				}),
			);

			setFiles([...files, ...filesWithPreview]);

			filesWithPreview.forEach((file) => handleUpload(file));
		},
	});

	useEffect(
		() => () => {
			// Make sure to revoke the data uris to avoid memory leaks
			files.forEach((file) => URL.revokeObjectURL(file.preview));
		},
		[files],
	);

	const handleTitleClick = () => {
		//@ts-ignore
		const { ref } = getInputProps();
		allowTitleClick && ref.current.click();
	};

	return (
		<Container className={className}>
			{title && (
				<Title className={titleClassName} onClick={handleTitleClick}>
					{title}
				</Title>
			)}

			<DropZoneContainer {...getRootProps()} disabled={disabled} className={dropZoneClassName}>
				{!uploaded.length && !loading && !disabled && (
					<UploadIconContainer>
						<Upload key='accept-icon' color='#64C8EB' />
					</UploadIconContainer>
				)}

				<input ref={dropZoneRef} {...getInputProps()} />

				<ThumbsContainer className={thumbsClassName}>
					<Thumbs files={uploaded} onDelete={onDelete} thumbClassName={thumbClassName} />

					<Thumbs loader files={files} />
				</ThumbsContainer>
			</DropZoneContainer>
		</Container>
	);
}

export default Uploader;
